// import Swiper JS
import Choices from 'choices.js/public/assets/scripts/choices.js';

window.Choices = Choices;

import './style.scss';

document.querySelectorAll('.js-choice').forEach(function (choicesEl) {
	const selectedValues = choicesEl.dataset.selected
		? JSON.parse(choicesEl.dataset.selected).map(String)
		: [];

	choicesEl = new Choices(choicesEl, {
		removeItemButton: true,
	});

	choicesEl.setChoiceByValue(selectedValues);
});
